import AddIconPng from "../assets/tools/Add.png";
import BackIconPng from "../assets/tools/Back.png";
import DeleteIconPng from "../assets/tools/delete.png";
import EditIconPng from "../assets/tools/Edit.png";
import FilterIconPng from "../assets/tools/Filter.png";
import LinkIconPng from "../assets/tools/Link .png";
import MediaIconPng from "../assets/tools/Media.png";
import PhotoIconPng from "../assets/tools/Photo.png";
import PreviewIconPng from "../assets/tools/Preview.png";
import SearchIconPng from "../assets/tools/Search.png";
import SettingIconPng from "../assets/tools/Setting.png";
import StadiumIconPng from "../assets/tools/Stadium.png";
import UploadIconPng from "../assets/tools/Upload.png";
import VideoIconPng from "../assets/tools/Video.png";

export const ToolIconMap = {
    add: AddIconPng,
    back: BackIconPng,
    delete: DeleteIconPng,
    edit: EditIconPng,
    filter: FilterIconPng,
    link: LinkIconPng,
    media: MediaIconPng,
    photo: PhotoIconPng,
    preview: PreviewIconPng,
    search: SearchIconPng,
    setting: SettingIconPng,
    stadium: StadiumIconPng,
    upload: UploadIconPng,
    video: VideoIconPng,
  };
  
